import { useEffect } from "react";
export var useSectionScroll = function () {
    useEffect(function () {
        var hash = window.location.hash;
        if (hash) {
            var element_1 = document.querySelector(hash);
            if (element_1) {
                setTimeout(function () {
                    element_1.scrollIntoView({ behavior: "smooth" });
                }, 100);
            }
        }
    }, []);
};
